<script setup lang="ts">
import { CULTURE, toFormattedRoomStringLong, toFormattedStringDateLong } from '@/composables/helpers'
import type { IAccoItem } from '@/composables/interfaces/apiInterfaces'
import t from '@/i18n/translations'
import { rooms } from '@/store/accosbar.store'
import { computed, onMounted, ref } from 'vue'
import AccoItemMiniSuccessPage from '../accoitem/AccoItemMiniSuccessPage.vue'
import AccoItemPlaceholder from '../accoitem/AccoItemPlaceholder.vue'

const props = defineProps<{
  items: IAccoItem[] | null | undefined
  direct: boolean
  lpenquiry: boolean
}>()

const showPlaceholder = ref(true)

const formattedDateString = computed(() => toFormattedStringDateLong() ?? '')

const formattedRoomString = computed(() => {
  return toFormattedRoomStringLong(rooms.value, CULTURE)
})

onMounted(() => {
  const section = document.getElementById('enquiry-success')
  if (section) {
    const sectionTop = section.offsetTop
    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth'
    })
  }
})

setTimeout(() => {
  showPlaceholder.value = false
}, 1000)

const title = props.direct ? t(`${CULTURE}.enquiry.success.direct`) : t(`${CULTURE}.enquiry.success.general`)
</script>

<template>
  <div id="enquiry-success" class="mb-4 p-2 md:container md:mx-auto">
    <div class="grid gap-8 md:gap-16">
      <div class="flex flex-col">
        <h1>{{ title }}</h1>
        <span class="text-2xl font-bold text-green-600">{{ t(`${CULTURE}.enquiry.success.status`) }}</span>
        <span class="text-xl text-green-600">{{ t(`${CULTURE}.enquiry.success.success`) }}</span>
      </div>
      <div v-if="props.items != null && props.items.length > 0 && !lpenquiry" class="flex flex-col">
        <div class="mb-1 text-xl font-semibold">{{ t(`${CULTURE}.enquiry.success.similarAccos`) }}</div>
        <div class="flex flex-col leading-5">
          <span>{{ formattedDateString }}</span>
          <span>{{ formattedRoomString }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="props.items != null && props.items.length > 0 && !lpenquiry"
      class="mb-8 mt-4 grid gap-4 md:container md:mx-auto md:grid-cols-2 md:flex-row md:justify-normal"
    >
      <AccoItemPlaceholder v-if="showPlaceholder" v-for="(_, index) in props.items.length" :key="index" />
      <AccoItemMiniSuccessPage v-else :item="acc" v-for="acc in props.items" :key="acc.companyId"></AccoItemMiniSuccessPage>
    </div>
  </div>
</template>
